module.exports = __webpack_public_path__ + "static/media/swipe-1-2.e868944.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CloudQuickPrinting/swipe-1-2.mp4
// module id = Mh27
// module chunks = 10